import {Pagination} from "antd";
import {useEffect, useState} from "react";

const Paging = ({setPage, pages, currentPage, setPageSize, pageSize}) => {

  const [totalPages, setTotalPages] = useState(0);

  useEffect(() => {
    // `pages` is undefined until a list has loaded (or when it is empty).
    const total = (Number(pages) || 0) * (Number(pageSize) || 20);
    if (totalPages !== total) {
      setTotalPages(total);
    }
  }, [pages, pageSize, totalPages]);


  return <Pagination aria-label="Навигация по страници"
                     className="ml-4 m-3"
                     showSizeChanger
                     showQuickJumper
                     showTotal={(total, range) => `${range[0]}-${range[1]} от общо ${total}`}
                     pageSizeOptions={[10, 20, 50, 100]}
                     pageSize={pageSize}
                     defaultPageSize={20}
                     current={currentPage}
                     total={totalPages}
                     onChange={(page, newPageSize) => {
                      setPage(page);
                      // Not every list offers a page-size picker (e.g. the audit log).
                      if (setPageSize && newPageSize !== pageSize) {
                        setPageSize(newPageSize);
                      }
                     }} />;
}

export default Paging
